import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class serviceAreasDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  noArea: boolean;
  noPickUpArea: boolean;
  noDropOffArea: boolean;
  onChange: Function;
  onChangeFilterNoArea: Function;
  onChangeFilterNoPickUpArea: Function;
  onChangeFilterNoDropOffArea: Function;


  private serviceAreasRef: any;
  private displayItems: any;

  /* @ngInject */
  constructor(private $serviceArea, private $log) {
    this.serviceAreasRef = this.$serviceArea();
  }

  $onInit() {

    if (!this.rowLimit) {
      this.rowLimit = 10;
    }

    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.serviceAreasRef.$asyncValues(ids)
        .then((serviceAreas) => {
          const displayItems = [];
          _.forEach(serviceAreas, (s) => {
            displayItems.push({id: s.areaId, value: s.areaName})
          })
          this.displayItems = displayItems;
        })
        .catch((error) => {
          this.$log.error('Failed to get branches', error);
        })
    } else {
      this.displayItems = [];
    }
  }



}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      noArea: '<?',
      noPickUpArea: '<?',
      noDropOffArea: '<?',
      canRemove: '<?',
      onChange: '&',
      onChangeFilterNoArea: '&',
      onChangeFilterNoPickUpArea: '&',
      onChangeFilterNoDropOffArea : '&'
    },
    template: require('./service-areas-display-list.html').default,
    controller: serviceAreasDisplayListCtrl
  });
